import React from 'react';
import TermsOfServicePage from '../legal/TermsOfServicePage.jsx';
import PrivacyPolicyPage from '../legal/PrivacyPolicyPage.jsx';
import CommercePage from '../legal/CommercePage.jsx';

const HUB_LEGAL_BACK = {
  backTo: '/support/legal',
  backLabel: '規約・ポリシーに戻る',
  embedded: true,
};

const DOC_COMPONENTS = {
  terms: TermsOfServicePage,
  privacy: PrivacyPolicyPage,
  commerce: CommercePage,
};

/**
 * HubLayout 内の法務文書ページ（公開版と同一コンポーネント・同一 API）
 */
export default function HubLegalDocumentPage({ docType }) {
  const Page = DOC_COMPONENTS[docType];
  if (!Page) return null;

  return (
    <div className="hub-main-content hub-enter-panel" data-panel-index="0">
      <Page {...HUB_LEGAL_BACK} />
    </div>
  );
}
